module.exports = __webpack_public_path__ + "img/package.7e653fa5.png";